import { type Registry as Services, service } from '@ember/service';
import { cached, tracked } from '@glimmer/tracking';
import { getOwnConfig, macroCondition } from '@embroider/macros';
import config from 'uplisting-frontend/config/environment';
import BaseController from 'uplisting-frontend/pods/base/controller';
import {
  isV2OverlayRoute,
  isV2PageRoute,
} from 'uplisting-frontend/utils/v2-page';

export default class ApplicationController extends BaseController {
  @service router!: Services['router'];
  @service features!: Services['features'];
  @service maintenance!: Services['maintenance'];

  @service('airbnb-guest-data-policy')
  airbnbGuestDataPolicy!: Services['airbnb-guest-data-policy'];

  closeAfter = config.notify.closeAfter;

  @tracked isLoading = true;

  @cached
  get isRegisterRoute(): boolean {
    return this.currentRouteName.startsWith('register.');
  }

  @cached
  get isLogoutRoute(): boolean {
    return this.currentRouteName.includes('logout');
  }

  // Dev/test-only /vrt gallery renders with no app chrome; false in prod.
  @cached
  get isVrtRoute(): boolean {
    if (macroCondition(getOwnConfig<{ enableVrt: boolean }>().enableVrt)) {
      return this.currentRouteName === 'vrt';
    }

    return false;
  }

  @cached
  get hideSidebar(): boolean {
    return this.isRegisterRoute || this.isLogoutRoute || this.isVrtRoute;
  }

  @cached
  get isV2Page(): boolean {
    return isV2PageRoute(this.currentRouteName, this.features);
  }

  @cached
  get isV2Overlay(): boolean {
    return isV2OverlayRoute(this.currentRouteName, this.features);
  }

  @cached
  get isV2Modal(): boolean {
    return ['xcalendar.starts', 'xcalendar.callback.airbnb'].includes(
      this.currentRouteName,
    );
  }
}
